import * as React from 'react';

import { DataStorage } from "../utils/DataStorage";


export function useDataStorage(deps: React.DependencyList): [DataStorage, (key: string, value: any) => void, () => void] {
  const [dataStorage, setDataStorage] = React.useState<DataStorage>(new DataStorage());

  const clearDataStorage = () => setDataStorage(new DataStorage());
  // eslint-disable-next-line
  React.useEffect(clearDataStorage, deps);

  const setDataStorageValue = React.useCallback((key: string, value: any): void => {
    dataStorage.set(key, value);
    setDataStorage(dataStorage);
  }, [dataStorage]);
  

  return [dataStorage, setDataStorageValue, clearDataStorage];
}